<template>
  <iframe :src="body" id="iid" :style="isPoint()" ref="openfield"></iframe>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  beforeDestroy() {
    // 240814----------------------------------------------------
    if (!this.Option().deleteImgNotUse) {
      clearInterval(this.interval);
    }
    clearInterval(this.color);
    // 1)
    // if (this.isClick) {
    //   clearInterval(this.link);
    // }
    if (this.Option().bodyLinkExternalBrowserUse) {
      clearInterval(this.link);
    }
    // 240814----------------------------------------------------
  },
  created() {
    this.params = false;
    if (this.$route.query.data) {
      this.params = JSON.parse(this.$route.query.data);
    }
    // this.params.type == "news";
    // ---------------------------------
    // 2)
    // this.isClick = this.Config().company == "ace" && this.isA();
    // ---------------------------------
    // this.$route.path.indexOf("read_mail") !== -1) &&

    // 귀뚜라미 - 예외처리
    if (this.Config().company == "kiturami") {
      this.isClick = this.isI();
    }

    // 3)
    // this.timeout = setTimeout(() => {
    //   clearInterval(this.interval);
    //   clearInterval(this.color);
    //   if (this.isClick) {
    //     clearInterval(this.link);
    //   }
    // }, 10000);
    this.timeout = setTimeout(() => {
      if (!this.Option().deleteImgNotUse) {
        clearInterval(this.interval);
      }
      clearInterval(this.color);
      if (this.Option().bodyLinkExternalBrowserUse) {
        clearInterval(this.link);
      }
    }, 10000);
    this.src = "/mobile_index/main/my";
  },
  mounted() {
    $("#iid").on("load", this.deleteImg);
  },
  props: ["body", "read", "did"],
  data() {
    return {
      interval: null,
    };
  },
  methods: {
    deleteImg() {
      var check = this;
      // 240814----------------------------------------------------
      // <연결문서입니다.> 버튼의 이벤트 이동 막기
      // href를 제거하려했으나, 이벤트를 막는 것으로 대체시킴.
      if (!this.Option().deleteImgNotUse) {
        this.interval = setInterval(() => {
          var doc =
            check.$refs.openfield.contentDocument ||
            check.$refs.openfield.contentWindow.document;

          var imgs = doc.querySelectorAll("img[src='/icons/medoc.gif']");
          if (imgs.length > 0) {
            clearInterval(check.interval);
            for (var i = 0; i < imgs.length; i++) {
              imgs[
                i
              ].parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.remove();
            }
          }
        }, 300);
      }
      // 4)
      // if (this.isClick) {
      //   this.link = setInterval(() => {
      //     var doc =
      //       check.$refs.openfield.contentDocument ||
      //       check.$refs.openfield.contentWindow.document;
      //     var link = doc.querySelectorAll("a");
      //     if (link.length > 0) {
      //       clearInterval(check.link);
      //       for (var i = 0; i < link.length; i++) {
      //         var returnhref = link[i].getAttribute("href");
      //         var href = "";
      //         if (returnhref.indexOf("javascript") !== -1) {
      //           href = returnhref;
      //           // returnhref=returnhref.split("javascript:window.open('")[1];
      //           // returnhref = returnhref.split("')")[0];
      //         } else {
      //           var url = "m60call://browser?urladdress=" + returnhref;
      //           // var url = link[i].getAttribute("href");

      //           var goto = `${window.location.origin}/mobile_index/viewer`;
      //           var setToken = this.replaceAll(this.getToKen(), "+", "$SIS$");
      //           href = `${goto}?url=${encodeURIComponent(
      //             url
      //           )}&token=${encodeURIComponent(setToken)}`;
      //         }

      //         // var href = encodeURIComponent(url);

      //         link[i].setAttribute("href", href);
      //         link[i].setAttribute("target", "_parent");
      //       }
      //     }
      //   }, 200);
      // }
      if (!this.Option().bodyLinkEnable) {
        const iframeDocument =
          check.$refs.openfield.contentDocument ||
          check.$refs.openfield.contentWindow.document;

        // href 값이 존재하면서 ""이 아닌 a 태그를 추출
        const links = iframeDocument.querySelectorAll('a[href]:not([href=""])');

        // 각 링크에 대해 evnet 기본동작 방지
        links.forEach((link) => {
          link.addEventListener("click", (event) => {
            event.preventDefault();
          });
        });
      }

      if (this.Option().bodyLinkExternalBrowserUse) {
        this.link = setInterval(() => {
          const doc =
            check.$refs.openfield.contentDocument ||
            check.$refs.openfield.contentWindow.document;
          const link = doc.querySelectorAll("a");
          if (link.length > 0) {
            clearInterval(check.link);
            for (let i = 0; i < link.length; i++) {
              const returnhref = link[i].getAttribute("href");
              let href = "";
              if (returnhref.indexOf("javascript") !== -1) {
                href = returnhref;
                // returnhref=returnhref.split("javascript:window.open('")[1];
                // returnhref = returnhref.split("')")[0];
              } else {
                const callHost =
                  this.Option().callExternalSyntax ?? "m60call://";
                const url = `${callHost}browser?urladdress=` + returnhref;
                console.log("openfiled.vue_ url : ", url);
                // var url = link[i].getAttribute("href");

                const goto = `${window.location.origin}/mobile_index/viewer`;
                const setToken = this.replaceAll(this.getToKen(), "+", "$SIS$");
                href = `${goto}?url=${encodeURIComponent(
                  url
                )}&token=${encodeURIComponent(setToken)}`;
              }

              // var href = encodeURIComponent(url);

              link[i].setAttribute("href", href);
              link[i].setAttribute("target", "_parent");
            }
          }
        }, 200);
      }
      // 240814----------------------------------------------------
      if (this.GetSystemColor == "dark") {
        this.color = setInterval(() => {
          var doc =
            check.$refs.openfield.contentDocument ||
            check.$refs.openfield.contentWindow.document;
          var color = doc.querySelectorAll("body");
          if (color.length > 0) {
            clearInterval(check.color);
            for (var i = 0; i < color.length; i++) {
              color[i].setAttribute("style", "color: #f2f2f2;");
            }
          }
        }, 200);
      }
    },
    // 5)
    // isPoint() {
    //   var sty = `width: 100%;
    //   height: 100%;
    //   overflow: hidden;
    //   border: 0;`;
    //   // 스크롤 안되는 문제가생겨서 주석처리
    //   // if (!this.isClick) {
    //   //   sty += "pointer-events: none;";
    //   // }
    //   return sty;
    // },
    isPoint() {
      let sty = `width: 100%;
      height: 100%;
      overflow: hidden;
      border: 0;`;
      // 240814----------------------------------------------------
      if (this.Option().bodyClickDisable) {
        sty += "pointer-events: none;";
      }
      // 240814----------------------------------------------------
      return sty;
    },
  },
  computed: {
    ...mapGetters("configjs", ["GetSystemColor"]),
    ...mapGetters("mainjs", ["GetMyInfo"]),
    isOpenField() {
      return this.body.toLowerCase().indexOf("openfiled") !== -1;
    },
  },
};
</script>

<style></style>
